import { render, staticRenderFns } from "./QuillEditorCustom.vue?vue&type=template&id=5cbd0512"
import script from "./QuillEditorCustom.vue?vue&type=script&lang=js"
export * from "./QuillEditorCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports